import { sanitize } from 'utils/sanitizeText'
import { getURL, baseInteraction, sendEvent } from './utils'

export const TagPushHome = {
    screenView: (url) => {
        let event = {
            event: 'screen_view',
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:home',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    interactionChatOpen: (url) => {
        let event = {
            event: 'interaction',
            element_type: 'select:icon:click',
            element_content: 'none:precisando-de-ajuda:none',
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:home',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    interactionBannerClick: (url) => {
        let event = {
            event: 'interaction',
            element_type: 'banner:button:click',
            element_content: `none:descubra-aqui&project-info-banner:banner`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:home',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    interactionLink: (url, text = 'none') => {
        let event = {
            event: 'interaction',
            element_type: 'box:link:click',
            element_content: `none:${sanitize(text)}:box-inferior`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:home',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    interactionFooterLink: (text = 'none') => {
        let event = {
            event: 'interaction',
            element_type: 'footer:link:click',
            element_content: `none:${sanitize(text)}:footer`,
            section_app: 'loja-virtual:alelo',
            screen_name: 'loja-virtual:home',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    }
}
